import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import {
  BrowserModule,
  provideClientHydration,
  withEventReplay,
} from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AppHeaderComponent } from './app-header/app-header.component';
import { HomeComponent } from './home/home.component';
import { RouterModule, Routes } from '@angular/router';
import { CommonService } from './common.service';
import {
  provideHttpClient,
  withFetch,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { AboutComponent } from './about/about.component';
import { GoogleAnalyticsService } from './google-analytics.service';
import { ConfigService } from './config.service';
import { SearchComponent } from './search/search.component';
import { SearchPaginationComponent } from './search-pagination/search-pagination.component';
import { SearchResultCardComponent } from './search-result-card/search-result-card.component';
import { HeaderSearchComponent } from './header-search/header-search.component';
import { SwaggerComponent } from './swagger/swagger.component';
import { HomeLinksComponent } from './home-links/home-links.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { OverlayModule } from '@angular/cdk/overlay';
import { TrainingCoursesComponent } from './training-courses/training-courses.component';
import { EbiHeaderComponent } from './ebi-header/ebi-header.component';
import { EbiFooterComponent } from './ebi-footer/ebi-footer.component';
import { FooterComponent } from "./footer/footer.component"
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { SharedModule } from './shared.module';
import { NgMaterialModule } from './ngmaterial.module';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { entryReducer } from './state/entry.reducer';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { environment } from '../environments/environment';
import { EntryEffects } from './state/entry.effect';
import { NgxPaginationModule } from 'ngx-pagination';
import { ReleaseNotesComponent } from './release-notes/release-notes.component';
const routes: Routes = [];

@NgModule({
  declarations: [
    AppComponent,
    AppHeaderComponent,
    HomeComponent,
    AboutComponent,
    SearchComponent,
    SearchPaginationComponent,
    SearchResultCardComponent,
    HeaderSearchComponent,
    SwaggerComponent,
    HomeLinksComponent,
    TrainingCoursesComponent,
    EbiFooterComponent,
    EbiHeaderComponent,
    FooterComponent,
    ReleaseNotesComponent
  ],
  exports: [RouterModule],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    BrowserAnimationsModule,
    CommonModule,
    OverlayModule,
    NgOptimizedImage,
    SharedModule,
    NgMaterialModule,
    NgxPaginationModule,
    StoreModule.forRoot({}),
    EffectsModule.forRoot([]),
    StoreDevtoolsModule.instrument({
      maxAge: 25, // Keep last 25 states
      logOnly: environment.production, // Restrict extension in prod mode
    }),
  ],
  providers: [
    CommonService,
    GoogleAnalyticsService,
    ConfigService,
    provideHttpClient(withInterceptorsFromDi(), withFetch()),
    provideClientHydration(withEventReplay()),
  ],
})

export class AppModule {}
